import React from "react"
import { ButtonLink } from "../generic/button-link"

interface Props {
    onActionSuccess?: () => void
}

export function RemerciementOnboardingCitoyen({onActionSuccess}: Props) {
    return (
        <div 
            css={{
                textAlign:"center",
                fontSize:"1rem"
            }}
        >
            <p
                css={{
                   fontWeight:"bold",
                   fontSize:"1.1rem"
                }}
            >
                Merci pour votre inscription !
            </p>
            <p>Pensez à valider votre email afin de valider complètement votre compte.</p>
            <p>(Astuce : si vous ne l’avez pas reçu pensez à vérifier dans vos spams)</p>
            <ButtonLink 
                label="Découvrir les projets"
                to="/projets"
            />
        </div>
    )
}